import { connect } from 'react-redux';
import * as actions from '../../actions/schedule';
import ScheduleOnDate from '../../components/schedule/ScheduleOnDate';

const mapStateToProps = ({ schedule }) => ({
  schedule: schedule.scheduleOnDate,
  date: schedule.date,
  isLoading: schedule.isLoading,
});

const mapDispatchToProps = dispatch => ({
  didMount: date => dispatch(actions.scheduleOnDate(date)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleOnDate);
